<template>
  <ValidationObserver
    ref="loginForm"
    v-slot="{ invalid, passes }"
  >
    <v-form
      rel="loginForm"
      @submit.prevent="passes(submitLogin(form))"
    >
      <v-card-text>
        <VTextFieldWithValidation
          rules="required"
          v-model="form.username"
          label="Username"
          name="login"
          prepend-icon="mdi-account"
          type="text"
          dense
        />
        <VTextFieldWithValidation
          rules="required"
          v-model="form.email"
          label="E-mail"
          name="email"
          prepend-icon="mdi-email"
          type="email"
          dense
        />
        <VTextFieldWithValidation
          rules="required"
          v-model="form.password"
          label="Heslo"
          name="password"
          prepend-icon="mdi-lock"
          type="password"
          dense
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          depressed
          height="40px"
          color="primary"
          :loading="isLoggin"
        >
          Přihlásit
        </v-btn>
      </v-card-actions>

      <v-alert
        v-if="errorMessage"
        type="error"
      >
        {{ errorMessage }}
      </v-alert>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex';
import VTextFieldWithValidation from '@/components/validators/VTextFieldWithValidation.vue';

export default {
  name: 'LoginForm',
  components: {
    VTextFieldWithValidation,
  },
  data() {
    return {
      form: {
        username: '',
        email: '',
        password: '',
      },
      errorMessage: null,
      isLoggin: false,
    };
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
    }),
    submitLogin(form) {
      if (!this.form.username.length
          || !this.form.username.length
          || !this.form.email.length) return;

      this.errorMessage = null;
      this.isLoggin = true;
      this.login(form)
        .then(() => {
          this.$router.push({
            name: 'home',
          });
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.errorMessage = 'Přihlašovací údaje nejsou správné';
          }
        }).finally(() => {
          this.isLoggin = false;
        });
    },
  },
};
</script>
